export default {
  // number of days ahead to show the scheduler in IntakeEndView
  daysUntilShowScheduler: 60,

  // number of days before the postcode open date when the lead should reappear in the leads
  daysBeforeCallbackToForwardOpenDate: 30,
};